(function ($) {
    'use_strict';
    /**
     * Creates the contact forms
     */

    var form = m4_form;
    var add_from= null;
    var errorMsg = new message("danger");
    var succesMsg = new message("success");
    var translate = m4;
    
    $(document).ready(function () {
        $("body").find("form.add_dadd").each(function () {
            add_from= $(this);
            form.create_form(add_from, form.add_success, form.add_fail);
        }); 
    });

    form.add_success = function (data,the_form) {
        the_form.resetForm();  
        succesMsg.removeAllMsg();
        succesMsg.createMessage(data);
        succesMsg.display();
    };

    form.add_fail = function (data) {
        errorMsg.removeAllMsg();
        errorMsg.createMessage(data.data);
        errorMsg.display();
    }; 
     
})(jQuery);